<template>
	<v-layout
		row
		wrap
		justify-center
	>
		<v-flex xl8>
			<v-data-iterator
				ref="iterator"
				:items="items"
				:pagination.sync="pagination"
				:search="search"
				:rows-per-page-items="rowsPerPageItems"
				:custom-filter="filterItems"
				:custom-sort="customSort"
				:hide-actions="items.length === 0"
				no-data-text="No users available"
				no-results-text="No matching users found"
				content-tag="v-layout"
				row
				wrap
			>
				<template v-if="items.length > 0" slot="header">
					<IteratorToolbar
						:sort-by="sortBy"
						:sort-name="sortName"
						:pagination="pagination"
						hide-sort
						hide-change-view
						@search="search = $event"
						@sort="sort"
						@pagination="changeSortDirection"
					/>
				</template>
				<ListAndCard
					slot="item"
					slot-scope="props"
					:image-text="props.item.realName"
					:card-type="1"
				>
					<template slot="title">
						<div class="headline">
							<span
								:title="props.item.realName"
								class="truncate"
							>
								{{ props.item.realName }}
							</span><br>
							<span v-if="props.item.email" class="subheading">
								{{ props.item.email }}
							</span>
						</div>
					</template>
					<!-- <template slot="additional">
						<v-flex
							v-if="$userCan('manage_users') && !project.isArchived"
							pt-0
							xs12
							sm4
							md3
							lg4
							xl4
						>
							<v-select
								:items="userLevels"
								v-model="props.item.access"
								item-value="value"
								item-text="label"
								hide-details
								:disabled="props.item.saving"
								:loading="props.item.saving"
								label="User Level"
								@change="$emit('update', $event, props.item)"
							/>
						</v-flex>
					</template> -->
				</ListAndCard>
			</v-data-iterator>
		</v-flex>
	</v-layout>
</template>

<script>
import { User } from '@/models/User';
import IteratorMixin from '@/mixins/IteratorMixin';
import IteratorToolbar from '@/components/IteratorToolbar';
import ListAndCard from '@/components/ListAndCard';

export default {
	components: {
		IteratorToolbar,
		ListAndCard,
	},
	mixins: [IteratorMixin],
	props: {
		items: { type: Array, default: null },
	},
	data() {
		return {
			sortBy: [
				{ name: 'Name', value: 'realName' },
			],
			pagination: {
				rowsPerPage: 12,
				sortBy: 'realName',
				descending: false,
				page: 1,
			},
			fuseOptions: {
				keys: ['realName'],
				minMatchCharLength: 2,
				threshold: 0.4,
				shouldSort: true,
			},
			userLevels: User.userLevels,
		};
	},
	computed: {
		// project() {
		// 	return this.$store.get('projects/currentProject');
		// },
	},
};
</script>

<style scoped lang="scss">
.headline {
	max-width: 100%;
	.truncate {
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		vertical-align: bottom;
		display: inline-block;
	}
}
</style>
